import { __rest, __assign } from 'tslib';
import * as React from 'react';
import { classNames } from 'uitk-react-utils';
import styles from './uitk-list.css';
var UitkListOrientationMap = [['inline', 'orientation-inline'], ['stacked', 'orientation-stacked']];
var UitkListOrientations = new Map(UitkListOrientationMap);
var UitkListSizeMap = [[1, 'size-1'], [2, 'size-2'], [3, 'size-3']];
var UitkListSizes = new Map(UitkListSizeMap);
var UitkListTypeMap = [['unordered', 'ul'], ['ordered', 'ol']];
var UitkListTypes = new Map(UitkListTypeMap);
var UitkListBulletMap = [['default', 'bullet-default'], ['no-bullet', 'bullet-none'], ['icon-alternate', 'bullet-icon-alternate'], ['icon-standard', 'bullet-icon-standard']];
var UitkListBullets = new Map(UitkListBulletMap);
var UitkListItemThemeMap = [['default', 'default-theme'], ['emphasis', 'emphasis-theme'], ['positive', 'positive-theme'], ['negative', 'negative-theme']];
var UitkListItemThemes = new Map(UitkListItemThemeMap);
var getClassNameList$1 = classNames.bind(styles);
var UitkListContext = React.createContext({});
var UitkList = function (props) {
  var bullet = props.bullet,
    children = props.children,
    className = props.className,
    data = props.data,
    orientation = props.orientation,
    size = props.size,
    type = props.type,
    spacing = props.spacing,
    attributes = __rest(props, ["bullet", "children", "className", "data", "orientation", "size", "type", "spacing"]);
  var baseClass = 'uitk-typelist'; // Temporary: name clash with menu
  var cssClassNames = getClassNameList$1(baseClass, orientation && baseClass + "-" + UitkListOrientations.get(orientation), size && baseClass + "-" + UitkListSizes.get(size), spacing && baseClass + "-spacing", className);
  // Renders the custom Tag
  var Tag = type && UitkListTypes.get(type) || 'ul';
  // Renders children if data is used
  var dataGuard = function (dataType) {
    return dataType[0].content !== undefined;
  };
  var newChildren = [];
  data === null || data === void 0 ? void 0 : data.forEach(function (item, index) {
    newChildren.push(React.createElement(UitkListItem, {
      key: "listitem-" + index
    }, dataGuard(data) ? [item && (item === null || item === void 0 ? void 0 : item.icon), item === null || item === void 0 ? void 0 : item.content] : item));
  });
  return React.createElement(Tag, __assign({
    className: cssClassNames
  }, attributes, {
    role: "list"
  }), React.createElement(UitkListContext.Provider, {
    value: {
      bullet: bullet,
      orientation: orientation,
      type: type,
      size: size
    }
  }, !data && children || newChildren || null));
};
UitkList.displayName = 'UitkList';
UitkList.defaultProps = {
  bullet: 'default',
  orientation: 'stacked',
  size: 2,
  type: 'unordered',
  spacing: true
};
var getClassNameList = classNames.bind(styles);
var UitkListItem = function (props) {
  var children = props.children,
    theme = props.theme,
    attributes = __rest(props, ["children", "theme"]);
  var context = React.useContext(UitkListContext);
  var bullet = context.bullet,
    orientation = context.orientation,
    size = context.size,
    type = context.type;
  var bulletClass = function () {
    // If bullet is default, set type as bullet style
    // if bullet is not default, set bullet as bullet style
    var value;
    if (bullet && type) {
      value = UitkListBullets.get(bullet) === 'bullet-default' ? "bullet-" + type : UitkListBullets.get(bullet);
    }
    return value;
  };
  var baseClass = 'uitk-typelist-item'; // Temporary: name clash with menu
  var bulletBaseClass = baseClass + "-bulletchar";
  var wrapperClassNames = getClassNameList(baseClass, baseClass + "-" + bulletClass(), bullet && bullet.includes('icon') && baseClass + "-bullet-icon", orientation && baseClass + "-" + UitkListOrientations.get(orientation), size && baseClass + "-" + UitkListSizes.get(size), bullet && !bullet.includes('icon') && theme && baseClass + "-" + UitkListItemThemes.get(theme), bullet && bullet.includes('icon') && theme && baseClass + "-bullet-icon-" + UitkListItemThemes.get(theme));
  var bulletCssClassNames = getClassNameList(bulletBaseClass, bulletBaseClass + "-" + bulletClass(), size && bulletBaseClass + "-" + UitkListSizes.get(size));
  var displayChildren = React.Children.toArray(children).map(function (child) {
    var _a;
    return ((_a = child === null || child === void 0 ? void 0 : child.type) === null || _a === void 0 ? void 0 : _a.displayName) === 'UitkIcon' ? React.createElement("div", {
      className: getClassNameList(baseClass + "-icon")
    }, child) : child;
  });
  // Set bullet markup?
  var bulletMarkup = bullet && UitkListBullets.get(bullet) === 'bullet-default' ? React.createElement("span", {
    "aria-hidden": "true",
    className: bulletCssClassNames
  }) : null;
  // Wrap children to make grid layout to work as expected with bullet markup
  var wrappedChildren = bulletMarkup ? React.createElement("span", {
    className: getClassNameList(baseClass + "-child")
  }, displayChildren) : displayChildren;
  return displayChildren ?
  // Disabling the following rule. The role was added in #2287
  // eslint-disable-next-line jsx-a11y/no-redundant-roles
  React.createElement("li", __assign({
    className: wrapperClassNames
  }, attributes, {
    role: "listitem"
  }), bulletMarkup, wrappedChildren) : null;
};
UitkListItem.displayName = 'UitkListItem';
export { UitkList, UitkListItem };